import carrierComponent from './carrier.component';
import CarrierCreate from './create'
import CarrierEdit from './edit'
import CarrierAll from './all'
let carrierModule = angular.module('carrier', [
    CarrierCreate,
    CarrierEdit,
    CarrierAll
  ])

  .component('carrier', carrierComponent)

  .config(($stateProvider) => {
    "ngInject";

    $stateProvider
      .state('carrier.edit', {
        url: '/edit/:id',
        component: 'carrieredit',
        data: {
          requireACL: 'setting-carrier.edit'
        }
      })

      .state('carrier.create', {
        url: '/create',
        component: 'carriercreate',
        data: {
          requireACL: 'setting-carrier.create'
        }
      })

      .state('carrier.all', {
        url: '/all/:page',
        component: 'carrierall',
        data: {
          requireACL: 'setting-carrier.view'
        }
      })
  })

  .name;

export default carrierModule;


// WEBPACK FOOTER //
// ./client/app/components/carrier/index.js